import { light } from './light';
import { DefaultTheme } from 'styled-components';
import { Theme } from 'types/enums/theme';
import { createTheme } from 'kl-b2c-ui-kit';

export const themes: Record<Theme, DefaultTheme> = {
    [Theme.Light]: createTheme(light),
};
